import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RecordImportSessionMutationVariables = Types.Exact<{
  input: Types.RecordImportSessionInput;
}>;


export type RecordImportSessionMutation = { __typename?: 'Mutation', recordImportSession: { __typename?: 'RecordImportSessionPayload', importSessionId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RecordImportSessionDocument = new TypedDocumentString(`
    mutation RecordImportSession($input: RecordImportSessionInput!) {
  recordImportSession(input: $input) {
    importSessionId
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RecordImportSession: build.mutation<RecordImportSessionMutation, RecordImportSessionMutationVariables>({
      query: (variables) => ({ document: RecordImportSessionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRecordImportSessionMutation } = injectedRtkApi;
